import { css } from '@bts-web/utils-style-engine';

export const emptyTransactionsStyles = css({
  fontSize: 'body.medium',
  fontWeight: 'body.medium',
  letterSpacing: 'body.medium',
  lineHeight: 'body.medium',
  color: 'neutrals.text_secondary',
  paddingTop: 'small',
  paddingBottom: 'medium',
});
